// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components-wpbbsa/wpbbsa-manage-access-to-report/wpbbsa-manage-access-to-report.component.scss
// module id = 1079
// module chunks = 0